var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoutesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 25C7 22.8667 9 20.9564 9 18.6C9 16.2436 7.20913 14.3333 5 14.3333C2.79087 14.3333 1 16.2436 1 18.6C1 20.9564 3 22.8667 5 25ZM5 25H20.3333C22.1743 25 23.6667 23.5076 23.6667 21.6667C23.6667 19.8257 22.1743 18.3333 20.3333 18.3333H17M21 11.6667C23 9.53333 25 7.62308 25 5.26667C25 2.91025 23.2092 1 21 1C18.7908 1 17 2.91025 17 5.26667C17 7.62308 19 9.53333 21 11.6667ZM21 11.6667H16.3333C14.4924 11.6667 13 13.1591 13 15C13 16.8409 14.4924 18.3333 16.3333 18.3333H17.8",
    stroke: "#20A8E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutesIcon);
export default __webpack_public_path__ + "static/media/routes_icon.271865d4617fc3550aec694d641d8907.svg";
export { ForwardRef as ReactComponent };